export const parsePhoneFromVCard = (vcard: string): string | undefined => {
  if (!vcard) return undefined;

  // Extract phone number from vCard format: TEL;type=CELL;type=VOICE;waid=919441239494:+91 94412 39494
  const telMatch = vcard.match(/TEL[^:]*:([^\n\r]+)/);
  if (telMatch) {
    const phone = telMatch[1].trim();
    // Format phone number: remove spaces and show in readable format
    const cleaned = phone.replace(/[^\d+]/g, '');
    if (cleaned.startsWith('+')) {
      // Format with space after country code
      return cleaned.replace(/(\+\d{2})(\d+)/, '$1 $2');
    }
    // If no +, add it for Indian numbers (starting with 91)
    if (cleaned.startsWith('91') && cleaned.length > 10) {
      return `+${cleaned.slice(0, 2)} ${cleaned.slice(2)}`;
    }
    return cleaned;
  }
  return undefined;
};
